import { NgClass } from '@angular/common';
import { Component, input, InputSignal } from '@angular/core';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { SECTORS } from '../../data/sectors.data';

@Component({
  selector: 'app-navbar-dropdown',
  imports: [NgClass, FontAwesomeModule],
  templateUrl: './navbar-dropdown.html',
  styleUrl: './navbar-dropdown.scss',
})
export class NavbarDropdown {

  dropdownType: InputSignal<string> = input('sectors')

  itemListHovered: string = 'public-security'
  changeSubmenu(submenuItem: string) {
    this.itemListHovered = submenuItem
  }

  sectors = structuredClone(SECTORS);
  publicSecurity = this.sectors[0];
  privateSecurity = this.sectors[1];
  inspections = this.sectors[2]

}
